import React from 'react';
import { getFontFamily } from '../../../Packages/fonts';
import { useCurrentBlockId } from '../../editor/EditorBlock';
import { setDocument, setSelectedBlockId, useDocument } from '../../editor/EditorContext';
import EditorChildrenIds from '../helpers/EditorChildrenIds';
export default function EmailLayoutEditor(props) {
    var _e, _t, _y, _10, _11;
    const childrenIds = (_e = props.childrenIds) !== null && _e !== void 0 ? _e : [];
    const document = useDocument();
    const currentBlockId = useCurrentBlockId();
    return (React.createElement("div", { onClick: () => {
            setSelectedBlockId(null);
        }, style: {
            backgroundColor: (_t = props.backdropColor) !== null && _t !== void 0 ? _t : '#F5F5F5',
            color: (_y = props.textColor) !== null && _y !== void 0 ? _y : '#262626',
            fontFamily: getFontFamily(props.fontFamily),
            fontSize: '16px',
            fontWeight: '400',
            letterSpacing: '0.15008px',
            lineHeight: '1.5',
            margin: '0',
            padding: '32px 0',
            width: '100%',
            minHeight: '100%',
        } },
        React.createElement("table", { align: "center", width: "100%", style: {
                margin: '0 auto',
                maxWidth: '600px',
                backgroundColor: (_10 = props.canvasColor) !== null && _10 !== void 0 ? _10 : '#FFFFFF',
                borderRadius: (_11 = props.borderRadius) !== null && _11 !== void 0 ? _11 : undefined,
                border: (() => {
                    const v = props.borderColor;
                    if (!v) {
                        return undefined;
                    }
                    return `1px solid ${v}`;
                })(),
            }, role: "presentation", cellSpacing: "0", cellPadding: "0", border: 0 },
            React.createElement("tbody", null,
                React.createElement("tr", { style: { width: '100%' } },
                    React.createElement("td", null,
                        React.createElement(EditorChildrenIds, { childrenIds: childrenIds, onChange: ({ block, blockId, childrenIds }) => {
                                setDocument({
                                    [blockId]: block,
                                    [currentBlockId]: {
                                        type: 'EmailLayout',
                                        data: Object.assign(Object.assign({}, document[currentBlockId].data), { childrenIds: childrenIds }),
                                    },
                                });
                                setSelectedBlockId(blockId);
                            } })))))));
}
//# sourceMappingURL=EmailLayoutEditor.js.map